<template>
  <div class="page--crud_list">
    <Popup ref="popup" @close="onConfigPopupClose">
      <div>
        <cp_config_edit id="popup" class="component" ref="cp_config_edit" :is="CpConfigEdit" :selectedConfig="selectedConfig" :currentSetting="currentSetting" :close="closePopup" :isCreate="isCreate"></cp_config_edit>
      </div>
    </Popup>
    <div class="tab-content">
      <vxe-table
          ref="table"
          class="main-table"
          size="mini"
          border
          show-header-overflow
          show-overflow
          highlight-hover-row
          :empty-text="$t('label.no_data_found')"
          
          :key="new Date().getTime()"
          :resizable="true"
          :data="cpConfigData">

        <vxe-table-column
            v-for="(field) in currentSetting" :key="field.key"
            :field="field.key"
            :title="field.key"
            :class-name="shouldHighlight"
            :width="field.width"
        >
          <template v-slot:header="{ columnIndex }">
            <div class="header-wrap">
              <div class="name">
                {{ tran(key, currentSetting[columnIndex].key) }}
              </div>
            </div>
          </template>
          <template v-slot="{ row }">
            <div v-if="field.type == 'boolean'">
              <input class="custom-checkbox" type="checkbox" v-model="row[field.key]" disabled="disabled">
              <div class="block-layer"></div>
            </div>

            <div v-else-if="field.type == 'datetime'">
              {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD HH:mm:ss") : field.fill ? $moment().format("YYYY-MM-DD HH:mm:ss") : "" }}
            </div>

            <div v-else-if="field.type == 's_to_hms'">
              {{ row[field.key] ? getTime(row[field.key]) : "00:00:00" }}
            </div>
            <div class="action" v-else-if="field.type == 'action-btn'" >
              <el-button
                  type="primary"
                  size="mini"
                  @click="editCpConfig(row)"
              >
                <fa :icon="['fas', 'edit']"/>
              </el-button>
              <el-button
                  type="info"
                  size="mini"
                  @click="duplicateCpConfig(row)"
              >
                <fa :icon="['fas', 'clone']"/>
              </el-button>
              <el-button
                  type="danger"
                  size="mini"
                  @click="deleteCpConfig(row.cp_config_id)"
              >
                <fa :icon="['fas', 'trash-alt']"/>
              </el-button>
            </div>

            <div v-else-if="field.type == 'float'">
              {{ getFloating( field, field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] ) }}
            </div>

            <div v-else>{{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] }}</div>

          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="ver-btn" >
        {{ tran(key, "create") }}
        <el-button v-for="(field,index) in fwVerConfig" @click="fwVerConfigClick(field)" :key="index">{{ field.fw_ver }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CpConfigEdit from "@/views/custom/cp_config_edit";
export default {
  props: ['data', 'currentSetting'],
  created() {
    this.CpConfigEdit = CpConfigEdit;
    console.log("data: " , this.data);
    console.log("cp_config_data: " , this.cpConfigData);
    console.log("currentSetting: " , this.currentSetting);
  },
  async beforeMount() {
    await this.fetchData();
    await this.$axios.get(`/cps/fwVerConfig`, {
    }).then(res=>{
      let data = res.data;
      console.log("fwVerConfig",data);
      this.fwVerConfig = data;
      return true;
    }).catch(err=>{ return false; });
  },
  methods: {
    async fetchData() {
      await this.$axios.get(`/cps/${this.data.cp_id}/cpConfig`, {
        params: {
        }
      }).then(res=>{
        let data = res.data;
        console.log("cpConfig",data);
        this.cpConfigData = data;

        return true;
      }).catch(err=>{ return false; });
    },
    clickedCell({ rowIndex }) {
      console.log("clickedCell:" + rowIndex);
      this.isCreate = false;
      this.selectedIndex = rowIndex;
      this.selectedConfig = this.cpConfigData[rowIndex];
      this.$refs.popup.show();
    },
    fwVerConfigClick(fwVerConfig) {
      console.log("fwVerConfigClick", fwVerConfig);
      this.isCreate = true;
      this.selectedConfig =
          {
          cp_id: this.data.cp_id,
          ip_address: "",
          mac_address: "",
          current: 0,
          pending: 0,
          config_json: fwVerConfig.config_json,
          description: "",
          fw_ver:  fwVerConfig.fw_ver
          };
        // Object.keys(this.selectedConfig).forEach(v => this.selectedConfig[v] = null);
      console.log("selectedConfig", this.selectedConfig);
      this.$refs.popup.show();

    },
    async closePopup() {
      await this.fetchData();
      this.$refs.popup.close();
    },
    shouldHighlight({ rowIndex }) {
      if(rowIndex == this.selectedIndex) {
        return "row-clicked";
      }
    },
    onConfigPopupClose() {
      if(this.$refs.cp_config_edit) {
      }
    },
    editCpConfig: function (cp_config) {
      console.log("editCpConfig:" + cp_config);
      this.isCreate = false;
      this.selectedConfig = cp_config;
      this.$refs.popup.show();
    },
    duplicateCpConfig: function (cp_config) {
      console.log("duplicate", cp_config);
      this.isCreate = true;
      this.selectedConfig = cp_config;
      this.$refs.popup.show();
      event.stopPropagation();
    },
    async deleteCpConfig (cp_config_id) {
      console.log("delete", cp_config_id);
      let type = "Delete";
      event.stopPropagation();
      let confirm = await this.$confirm(`Are you sure to delete cp config ID: ${cp_config_id}`  , type, {
        confirmButtonText: type,
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).catch(() => {
        console.log("cancel")
      });
      if(!confirm) return;
      await this.$axios.delete(`/cps/${cp_config_id}/cpConfig`).then(res=>{
        this.fetchData();
        return true;
      }).catch(err=>{
        console.error(err);
        return false;
      });
    }
  },
  data() {
    return {
      key: "",
      selectedIndex : -1,
      selectedConfig : null,
      isCreate: false,
      cpConfigData: null,
      fwVerConfig: []
    }
  }
}
</script>

<style lang="scss">
  .vxe-table--body {
    .row-clicked {
      background: #ffe48d;
    }
    .action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      :first-child{
        margin-right: 0px !important;
      }
      &:not(:first-child) {
        margin-left: 0px !important;
      }
      .el-button{
        padding: 7px 7px;
      }
    }
  }
  .ver-btn {
    margin: 8px;
  }
</style>